import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'bordered';
}
export function Card({
  className,
  variant = 'default',
  children,
  ...props
}: CardProps) {
  return <div className={cn('rounded-lg bg-white overflow-hidden', variant === 'default' ? 'shadow-xl' : 'border-2 border-dashed border-gray-300', className)} {...props} data-id="element-266">
      {children}
    </div>;
}